<footer fxLayoutAlign="center">
  <mat-icon svgIcon="cash&credit" class="logo" inline/>
</footer>
